import Accordion from 'components/common/Accordion/Accordion';
import ContainerHeader from 'components/common/ContainerHeader';
import { format, isValid, parse } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import { Trip } from 'services/dataService';
import styled from 'styled-components';
import { colors, containerStyles } from 'styles/shared';



const Container = styled.div`
  width: 54.4rem;
  height: 81.8rem;
  padding: 3.9rem 4.8rem 2rem 4.5rem;
  margin-bottom: 5.4rem;
  ${containerStyles};
`;

const Header = styled(ContainerHeader)`
  margin-bottom: 1rem;
`;

SmallComponent.propTypes = {
  trips: PropTypes.arrayOf(PropTypes.object).isRequired
};

function tripContent(trip: Trip) {
  return (
    <div>Risk Level: {trip.risk_level}<br /><br />
    Requirements: <ul>
        <li>Masks: {trip.requirements.masks}</li>
        <li>Tests: {trip.requirements.tests}</li>
        <li>Quarantine: {trip.requirements.quarantine}</li>
      </ul><br />
      Statistics: <ul>
        <li>Total Cases: {trip.total_cases}</li>
        <li>New Cases: {trip.new_cases}</li>
        <li>Total Deaths: {trip.total_deaths}</li>
        <li>New Deaths: {trip.new_deaths}</li>
      </ul><br />
      Government Response: <ul>
        <li>Government Response: {trip.government_response_index}</li>
        <li>Stringency: {trip.stringency_index}</li>
        <li>Containment and Health: {trip.containment_and_health_index}</li>
        <li>Economic Support: {trip.economic_support_index}</li>
      </ul>
    </div>
  );
}

function SmallComponent({trips, title}) {
  let sectionTitle = title;
  let items: any[] = [];

  for (const trip of trips) {
    let date = parse(trip, "MM-dd-yyyy", new Date());
    if (!isValid(date)) {
      date = new Date();
    }
    
    items.push(
      {
        id: trip.id,
        text: `${format(date, "MM-dd-yyyy")}: ${trip.to.replace(/^(, )/, "").replace(/ (\(.*\))$/, "")}`,
        color: colors.green_main,
        risk_level: trip.risk_level,
        content: tripContent(trip)
      })
  }

  if (items.length > 0) {
    items[items.length - 1].lastItem = true;
  }
  
  function render() {
    return (
      <Container>
        <Header>{sectionTitle}</Header>
        {/* {items.map((item: any) => {
          return <TripItem key={item.id} trip={item} />;
        })} */}
        <Accordion items={items} height={81.8} />
      </Container>
    );
  }

  return render();
}

export default SmallComponent;
